var _metadata, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeneralmotors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 496,
    viewBox: "0 0 131.233 131.233",
    width: 496,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#0671d8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m64 0c-35.3462 0-64 28.6538-64 64v368c0 35.3462 28.6538 64 64 64h368c35.3462 0 64-28.6538 64-64v-368c0-35.3462-28.6538-64-64-64zm0 32h368c17.6731-.00004 32 14.3269 32 32v368c0 17.6731-14.3269 32-32 32h-368c-17.6731 0-32-14.3269-32-32v-368c0-17.6731 14.3269-32 32-32z",
    transform: "scale(.26458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m224 336v32h176v-32z",
    transform: "scale(.26458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m224 128v172h36v-140h36v140h36v-140h24c6.62742 0 12 5.37258 12 12v128h36v-132c0-22.0914-17.9086-40-40-40z",
    transform: "scale(.26458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m132 128c-22.0914.00001-40 17.9086-40 40v92c0 22.0914 17.9086 40 40 40h32v8c0 15.464-14.3269 28-32 28h-20v32h20c37.5554 0 68-26.8629 68-60v-180zm8 32h24v108h-24c-6.62742 0-12-5.37258-12-12v-84c0-6.62742 5.37258-12 12-12z",
    transform: "scale(.26458)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralmotors);
export default __webpack_public_path__ + "static/media/generalmotors.aedd97e9f4f122891fd009e6818d7c03.svg";
export { ForwardRef as ReactComponent };